import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlatformService } from '../../services/platform.service';
import { AnimationController } from '@ionic/angular';

interface Feature {
  icon: string;
  title: string;
  description: string;
  route?: string;
}

interface Stat {
  number: string;
  label: string;
}

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  constructor(
    private animationCtrl: AnimationController,
    private platformService: PlatformService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.platformService.isDesktop()) {
      this.router.navigate(['/login']);
      return;
    }
    this.animateOnLoad();
  }

  private animateOnLoad() {
    const heroAnimation = this.animationCtrl
      .create()
      .addElement(document.querySelector('.hero-content')!)
      .duration(1000)
      .fromTo('opacity', '0', '1')
      .fromTo('transform', 'translateY(50px)', 'translateY(0)');

    heroAnimation.play();
  }

  startFree() {
    this.router.navigateByUrl("/Inscription");
    // Navigation vers la page d'inscription
  }

  connexion() {
    this.router.navigateByUrl("/login");
    // Ouvrir la démo ou naviguer vers une page de démo
  }

  onFeatureClick(feature: Feature) {
    if (feature.route) {
      // Navigation vers la fonctionnalité
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToInscription() {
    this.router.navigate(['/Inscription']);
  }

} 